// extracted by mini-css-extract-plugin
export default {"root":"Page_root__vK7cV","content":"Page_content__l28Js","error-block":"Page_error-block__nhWRc","errorBlock":"Page_error-block__nhWRc"};